module.exports = __webpack_public_path__ + "static/media/check.9e9e4f7b.svg";